import React from "react";

const ArrowRight: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 1024 1024"
    width={200}
    height={200}
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M770.8672 454.144a76.8 76.8 0 0 1 7.8848 99.9424l-7.4752 8.6016-409.6 412.9792a76.8 76.8 0 0 1-116.4288-99.5328l7.4752-8.6016L608.256 508.928 253.1328 156.9792A76.8 76.8 0 0 1 245.248 56.9344L252.6208 48.3328a76.8 76.8 0 0 1 100.0448-7.8848l8.6016 7.3728 409.6 406.3232z" />
  </svg>
);

export default ArrowRight;
